import React from "react";
const Cross = (props) => (React.createElement("svg", Object.assign({ width: "25", height: "25", viewBox: "0 0 25 25", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M24.1 2.4L21.9.3 12.2 10 2.4.3.3 2.4l9.7 9.8-9.7 9.7 2.1 2.2 9.8-9.8 9.7 9.8 2.2-2.2-9.8-9.7z" })));
export default Cross;
